import { EventViewData } from 'components/eventView/pages/eventData';

export const FredrikstadEvent: EventViewData = {
    eventId: 'fredrikstad',
    mapId: '176cd39b-396d-4c88-9b50-df2b815c8a99',
    guideId: '959f1edb-9aec-4504-a1c8-477164de12b3',
    eventInfo: {}
};
